import { translate } from "app/filters/i18nFilter";

function getUpdateDateOptionLabel(optionKey: string, isForChip = false): string {
    const key = `si.find_apps.filters.updateDate.option.${optionKey}`;
    const keyForChip = `si.find_apps.filters.updateDate.option.${optionKey}.chip`;

    if (isForChip && translate(keyForChip) !== keyForChip) {
        return translate(keyForChip);
    }

    return translate(key);
}

export default getUpdateDateOptionLabel;
